import { render, staticRenderFns } from "./SavedWorklists_new.vue?vue&type=template&id=551d8902&scoped=true"
import script from "./SavedWorklists_new.vue?vue&type=script&lang=js"
export * from "./SavedWorklists_new.vue?vue&type=script&lang=js"
import style0 from "./SavedWorklists_new.vue?vue&type=style&index=0&id=551d8902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d8902",
  null
  
)

export default component.exports